import { DocumentError } from '@/gen/artifacts/v1/model_pb'

export const CONTACT_US_LINK_LABEL = 'Contact us'
export const CONTACT_US_SUFFIX = 'for assistance.'

export const documentErrorMessage: Record<DocumentError, string> = {
  [DocumentError.UNSPECIFIED]: '',
  [DocumentError.EMPTY]: 'File could not be processed because it contains no textual data.',
  [DocumentError.ENCRYPTED]:
    'File is encrypted and cannot be processed by Lema. Un-encrypt the file and upload it again.',
  [DocumentError.UNKNOWN_CATEGORY]: 'File could not be classified into a category.',
  [DocumentError.UNSUPPORTED_TYPE]:
    'File type is not supported. Convert to a supported format (pdf, txt, csv, docx, xlsx) and try again.',
  [DocumentError.UNKNOWN_COMPANY]:
    'File could not be associated with a third-party. Try uploading it via the third-party tray.',
  [DocumentError.NO_TEXT_EXTRACTED]:
    'We could not read any content from this file, so it has not been included in the assessment.',
  [DocumentError.UNKNOWN_ERROR]: 'File could not be processed.',
}
